import {
  USER_FETCH_REQUESTED,
  USER_FETCH_SUCCESS,
  USER_FETCH_FAILED,
} from './actionTypes'
import { UserActionTypes } from './types'

const initialState = {
  data: null,
  loading: false,
  error: null,
}

const reducer = (state = initialState, action: UserActionTypes) => {
  switch (action.type) {
    case USER_FETCH_REQUESTED:
      return { ...state, loading: true }
    case USER_FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload }
    case USER_FETCH_FAILED:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default reducer
